import appGlobalScript from '/Users/kasimir/projects/lahitapiola/duet-design-system/packages/components/src/global/duet-global.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
